import React from 'react';
import objStr from 'obj-str';
import useTranslation from 'next-translate/useTranslation';
import { useAppSelector } from '@/configureStore';
import { selectDisplayTax } from '@stores/preferences';

import type { AppRootState } from '@/configureStore';

interface IPriceDisplay {
  price: IProductPrice;
  unitOfMeasure: {
    description: string;
    itemsPerUnit: number;
  };
  type?: string;
  priceClassname?: string;
  descriptionClassname?: string;
}

export const PriceDisplay = ({ price, unitOfMeasure, ...props }: IPriceDisplay) => {
  const { t, lang } = useTranslation('common');
  const displayTax: boolean = useAppSelector((state: AppRootState) => selectDisplayTax(state));
  const taxKey = displayTax ? 'incTax' : 'exTax';
  const priceDetails = price[taxKey];
  const pricePerUnitString =
    unitOfMeasure.itemsPerUnit > 1
      ? unitOfMeasure.description.replace(
          '#PRICE#',
          `${new Intl.NumberFormat(lang, { style: 'currency', currency: 'EUR' }).format(
            price[taxKey].numeric / unitOfMeasure.itemsPerUnit
          )}`
        )
      : '';

  const priceClassname = objStr({
    h3: true,
    'mr-2': true,
    //@ts-expect-error: -
    [props.priceClassname]: !!props.priceClassname
  });

  const descriptionClassname = objStr({
    'text-sm': true,
    'fw-medium': true,
    //@ts-expect-error: -
    [props.descriptionClassname]: !!props.descriptionClassname
  });

  return (
    <div>
      <div>
        <span className={priceClassname}>{priceDetails.formatted}</span>
        <span className={descriptionClassname}>{pricePerUnitString}</span>
      </div>
      <div>
        <span className="text-muted text-xs text-nowrap">{displayTax ? t('label.inc-tax') : t('label.ex-tax')}</span>
      </div>
    </div>
  );
};
